import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
import { SubscriptionsService } from '../../../services/subscriptions.service';
import { GlobalFlagsService } from '../../../services/global-flags.service';
import { OAuthService } from '../../../services/oauth.service';

import { DialogComponent } from '../../commons/dialog/dialog.component';

// Mocks
import { SubscriptionsMockup } from './subscriptions.mockup';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {

  constructor(private subscriptionsService: SubscriptionsService,
    private globalFlagsService: GlobalFlagsService,
    private router: Router,
    private route: ActivatedRoute,
    private oAuthService: OAuthService,
    private dialog: MatDialog) { }

  isLoading: boolean;
  subscriptionsArray = null;
  public = false;
  token: string;
  userId: string;
  sub: any;

  ngOnInit() {
    this.isLoading = true;
    this.subscriptionsArray = SubscriptionsMockup.subsArray;
    let subscriptions;
    // With email
    if (this.router.url !== '/user/edit-notifications') {
      this.oAuthService.logout();
      this.public = true;
      this.sub = this.route.params.subscribe(params => {
        this.userId = params['idUserProfile'];
        this.token = params['token'];
        const obj = {
          token: this.token,
          userId: this.userId
        };
        subscriptions = from(this.subscriptionsService.getSubscriptionsToken(obj));
      });
    } else {  // Normal usage
      subscriptions = from(this.subscriptionsService.getSubscriptions());
    }

    subscriptions
      .subscribe((res) => {
        this.subscriptionsArray = res;
        this.isLoading = false;
      }, (err) => {
        if (err.message === 'Not found: Invalid token.') {
          const data = { message: 'The link is invalid' };
          this.dialog.open(DialogComponent, { data });
          this.globalFlagsService.displayLoad(false);
          this.router.navigate(['/login']);
        }
        throw err;
      });
  }

  async saveSubscriptions() {
    this.globalFlagsService.displayLoad(true);

    this.public ? await this.subscriptionsService.saveSubscriptionsToken(this.subscriptionsArray, {
      'userId': this.userId,
      'token': this.token
    }) :
      this.subscriptionsService.saveSubscriptions(this.subscriptionsArray);

//     saveSubs
//       .subscribe((res) => {
        const message = 'Your notifications have been updated';
        this.globalFlagsService.pushSuccessAlert({ message });
        window.scrollTo(0, 0);
        this.globalFlagsService.displayLoad(false);
//       }, (err) => {
//         this.globalFlagsService.displayLoad(false);
//         const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
//         const data = { message: `${errMsg}. Please try again.` };
//         const dialogRef = this.dialog.open(DialogComponent, { data });
//         throw err;
//       });
  }

}
